import React from 'react';
import './index.scss';

const Page404 = () => (
    <div className="page-404-container">
        <h1 className="page-404-title">
            404
        </h1>

        <p className="page-404-paragraph">
            עמוד לא נמצא.
        </p>
    </div>
);

export default Page404;
